import styled from 'styled-components';
import {
    Banner,
    DialogBody,
    ModalDialog,
} from '@zillow/constellation';

export const StyledBanner = styled(Banner)`
    margin: -8px -24px 0px -24px;
`;

export const StyledModalDialog = styled(ModalDialog)`
    && ${DialogBody} {
        padding-top: 0px;
    }
`;
